import PopUpIcon from "../../assets/images/PopUpIcon";
import Button from "./cta/Button";
import { ErrorPopUpButton, PopUpButton } from "./styles/CommonStyles";
import WarningIcon from "../../assets/images/WarningIcon";
import ReactDOM from 'react-dom';
export interface ModalProps {
  buttonText: string;
  popUpMsg: string;
  popUpTitle: string | null;
  isOpen: boolean;
  onClose: () => void;
  icon?: any;
  isSucessMessage?:boolean;
}

const PopupModal = ({
  popUpTitle,
  popUpMsg,
  isOpen,
  buttonText,
  onClose,
  isSucessMessage=true,
  icon =isSucessMessage? <PopUpIcon />:<WarningIcon/>,
}: ModalProps) => {

  return ReactDOM.createPortal(
    <>
      {isOpen && (
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 transition-opacity"
              aria-hidden="true"
            >
              <div className="absolute inset-0 bg-blackColor bg-opacity-35 "></div>
            </div>

            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>

            <div
              className="inline-block align-bottom bg-whiteColor w-[488px] h-[479px]  rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              <div className="flex flex-col mt-20 items-center justify-center ">
                {icon}
                <div className="text-popUpTitleColor mt-7 popUpModelWithcancelButton px-14 text-center font-poppins">
                  {popUpTitle}
                </div>
                <div className="smallText text-loginSubTitle text-center mt-5  "> {popUpMsg}</div>
                <div className="mt-14" onClick={onClose}>
                  <Button
                    handleClick={function (): void {}}
                    buttonText={buttonText}
                    className={isSucessMessage ? PopUpButton : ErrorPopUpButton}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>,
    document.body
  );
};
export default PopupModal;
